import React, { FormEvent, useState } from "react";
import { useSelector } from "react-redux";

import Input from "Components/Form/Input";
import PageHeader from "Components/Pages/Header";
import PageWrapper from "Components/Pages/Wrapper";
import { Pagination } from "Components/Pagination";
import Breadcrumb from "Components/Shared/Breadcrumb";

import { useQuery } from "react-query";
import { getSchedulesListAPI } from "Requests/SchedulePartners";
import { Button } from "Components/Button";
import moment, { Moment } from "moment";
import InputDate from "Components/Form/InputDate";

import { createToast } from "../../Utils/toastFunc";
import { OrderList } from "./components/OrdersList";
import { ContentHolder } from "./styles";
import "react-dates/lib/css/_datepicker.css";
import "moment/locale/pt-br";
import { ModalViewOrder } from "./components/ViewOrderModal";

moment.locale("pt-br");

const PartnerOrder = () => {
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [date, setDate] = useState<Moment | undefined>();
  const [openModalDetail, setOpenModalDetail] = useState(false);
  const [selectedOrderId, setSelectedOrderId] = useState(0);
  const [filters, setFilters] = useState<{
    search: string;
    date: Moment | undefined;
  }>({
    search: "",
    date: undefined,
  });

  const userData = useSelector((state: any) => state.User.userData);
  const partnerName = userData?.client_name || "";

  const partnersOrder = useQuery({
    queryFn: () =>
      getSchedulesListAPI({
        page,
        search: filters.search,
        date: filters.date?.format("YYYY-MM-DD"),
      }),
    queryKey: ["partners-orders", page, filters],
    refetchOnWindowFocus: false,
  });

  function handlePagination(e: { currentPage: number }) {
    if (page === e.currentPage) return;
    setPage(e.currentPage);
  }

  function handleSubmit(event: FormEvent) {
    event.preventDefault();
    if (!search && !date)
      return createToast("error", "Selecione um tipo de busca");
    setFilters({
      search,
      date,
    });
  }

  const clearFilters = () => {
    setFilters({
      search: "",
      date: undefined,
    });
    setDate(undefined);
    setSearch("");
  };

  const onSelectOrderId = (id: number) => {
    setSelectedOrderId(id);
    setOpenModalDetail(true);
  };

  return (
    <PageWrapper className="entry-app-content ">
      <ContentHolder className="content-holder ">
        <div className="page-heading order-home-list">
          <div className="wrapper-header-content">
            <PageHeader title="Listagem todos os agendamentos">
              <Breadcrumb
                list={[
                  {
                    path: "#",
                    label: `Listagem agendamentos parceiros ${partnerName}`,
                    current: true,
                  },
                ]}
              />
            </PageHeader>
          </div>

          <div className="filters-holder">
            <div className="filters-order">
              <form className="select-search-submit" onSubmit={handleSubmit}>
                <Input
                  readOnly={false}
                  placeholder="Buscar por nome do paciente"
                  value={search}
                  onChange={({ target }: any) => setSearch(target.value)}
                  type="text"
                  error=""
                  id="search"
                  description=""
                  label=""
                  mask=""
                  maskChar=""
                  maxLength={200}
                  min={1}
                  multiline={false}
                  onBlur={() => {}}
                  onFocus={() => {}}
                  onKeyPress={() => {}}
                  purple={false}
                  required={false}
                  small={false}
                />
                <InputDate
                  id="date_input"
                  value={date}
                  onDateChange={(newDate: Moment) => setDate(newDate)}
                  error=""
                  blockPastChanges={false}
                />
                <Button onClick={handleSubmit} type="submit">
                  {" "}
                  Buscar{" "}
                </Button>
                <Button onClick={clearFilters} textButton>
                  {" "}
                  Limpar busca{" "}
                </Button>
              </form>
            </div>
          </div>
        </div>

        <OrderList
          orderList={partnersOrder?.data?.data}
          loading={partnersOrder.isLoading}
          onSelectOrderId={onSelectOrderId}
        />
      </ContentHolder>
      <div className="pagination-wrapper">
        {!partnersOrder.isLoading &&
          partnersOrder.data?.last_page &&
          partnersOrder.data.last_page > 1 && (
            <>
              <Pagination
                totalRecords={partnersOrder?.data?.last_page}
                currentPageSelected={partnersOrder?.data.current_page}
                pageLimit={1}
                pageNeighbours={1}
                onPageChanged={(e) => handlePagination(e)}
              />
            </>
          )}
      </div>

      {openModalDetail && (
        <ModalViewOrder
          openModal={openModalDetail}
          closeModal={() => setOpenModalDetail(false)}
          selectedOrderId={selectedOrderId}
        />
      )}
    </PageWrapper>
  );
};

export default PartnerOrder;
